import { isProductSpecificDiscount } from '../priceRules/priceRulesHelpers';
function getOrderLinePrice(orderLine, excludePant = true) {
    if (!orderLine)
        return 0;
    if (excludePant && orderLine.name.toLowerCase() === 'pant')
        return 0;
    let price = (orderLine.priceBefore || orderLine.price || 0) * (orderLine.quantity || 0);
    for (const subLine of orderLine.subLines) {
        price += getOrderLinePrice(subLine, excludePant);
    }
    return price;
}
function getOrderLineDiscountValue(orderLine) {
    if (!orderLine)
        return 0;
    if (isProductSpecificDiscount(orderLine.discount)) {
        return orderLine.discount.discountValue * orderLine.quantity;
    }
    let result = 0;
    for (const subLine of orderLine.subLines) {
        result += getOrderLineDiscountValue(subLine);
    }
    return result;
}
function orderLineSetSkipInTotalRabat(orderLine) {
    if (!orderLine)
        return;
    Object.assign(orderLine, { skipInTotalRabat: true });
    for (const subLine of orderLine.subLines) {
        orderLineSetSkipInTotalRabat(subLine);
    }
}
export { getOrderLinePrice, getOrderLineDiscountValue, orderLineSetSkipInTotalRabat };
